import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createSuccessFlagTitle: {
		id: 'backlog.flags.split-issue-success.create-success-flag-title',
		defaultMessage: 'You\'ve created issue "{issueKey}"',
		description: 'Title for success flag when a single issue from split issue',
	},
	createSuccessFlagTitleIssueTermRefresh: {
		id: 'backlog.flags.split-issue-success.create-success-flag-title-issue-term-refresh',
		defaultMessage: 'You\'ve created "{issueKey}"',
		description: 'Title for success flag when a single issue from split issue',
	},
	multiplesIssuesCreatedSuccessFlagTitle: {
		id: 'backlog.flags.split-issue-success.multiples-issues-created-success-flag-title',
		defaultMessage: "You've created {issueCount, plural, one {# issue} other {# new issues}}",
		description: 'Title for success flag when multiple issues created from split issue',
	},
	createSuccessFlagDescription: {
		id: 'backlog.flags.split-issue-success.create-success-flag-description',
		defaultMessage: 'It\'s linked to issue "{issueKey}".',
		description: 'Description for success flag when a single issue is created from split issue',
	},
	createSuccessFlagDescriptionIssueTermRefresh: {
		id: 'backlog.flags.split-issue-success.create-success-flag-description-issue-term-refresh',
		defaultMessage: 'It\'s linked to work item "{issueKey}".',
		description: 'Description for success flag when a single issue is created from split issue',
	},
	multipleIssuesCreatedSuccessFlagDescription: {
		id: 'backlog.flags.split-issue-success.multiple-issues-created-success-flag-description',
		defaultMessage: 'They\'re linked to issue "{issueKey}".',
		description: 'Description for success flag when multiple issues are created from split issue',
	},
	multipleIssuesCreatedSuccessFlagDescriptionIssueTermRefresh: {
		id: 'backlog.flags.split-issue-success.multiple-issues-created-success-flag-description-issue-term-refresh',
		defaultMessage: 'They\'re linked to work item "{issueKey}".',
		description: 'Description for success flag when multiple issues are created from split issue',
	},
	viewIssueLinkText: {
		id: 'backlog.flags.split-issue-success.view-issue-link-text',
		defaultMessage: 'View {numIssues, plural, one {issue} other {issues}}',
		description: 'CTA for success flag when issue is split',
	},
	copyLink: {
		id: 'backlog.flags.split-issue-success.copy-link',
		defaultMessage: 'Copy link',
		description: 'CTA for copying issueDiscovery link',
	},
	linkCopied: {
		id: 'backlog.flags.split-issue-success.link-copied',
		defaultMessage: 'Copied',
		description: 'Text to displayed when user copies the link',
	},
	multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
		id: 'backlog.flags.split-issue-success.multiples-issues-created-success-flag-title-issue-term-refresh',
		defaultMessage:
			"You've created {issueCount, plural, one {# work item} other {# new work items}}",
		description: 'Title for success flag when multiple issues created from split issue',
	},
	viewIssueLinkTextIssueTermRefresh: {
		id: 'backlog.flags.split-issue-success.view-issue-link-text-issue-term-refresh',
		defaultMessage: 'View{numIssues, plural, one {} other { work items}}',
		description: 'CTA for success flag when issue is split',
	},
});
